import { SpeedInsights } from "@vercel/speed-insights/react";

export default SpeedInsights;
